import { allExperiments } from "./src/internal";

export * from "./src/defineExperiment";
export * from "./src/experiments/index";
export * from "./src/jotai";
export * from "./src/AbServiceContext";
export * from "./src/AbServiceProvider";

export const ABSERVICE_EXPERIMENTS: readonly string[] = [
  // extra A/B experiments to register (without global params)
  ...allExperiments.map((it) => it.name),
];
